export default __webpack_public_path__ + "static/media/K2500Gallery6.80367f34.jpg";